/* istanbul ignore file */
import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { EMPLOYEE_WORKING_STATUSES } from 'domain/shared/employee';

interface EmployeeWorkingStatusDropdownProps extends DefaultDropdownProps {
  excluded?: string[];
}

const EmployeeWorkingStatusDropdown = ({ excluded, ...props }: EmployeeWorkingStatusDropdownProps) => {
  return (
    <Dropdown
      placeholder="Choose Worker Working Status"
      options={Object.entries(EMPLOYEE_WORKING_STATUSES)
        .filter(status => !excluded || !excluded.includes(status[0]))
        .map(entry => {
          const [value, label] = entry;
          return {
            value,
            label: label as string,
          };
        })}
      label="Worker Working Status"
      {...props}
    />
  );
};

export default EmployeeWorkingStatusDropdown;
